import { useEffect } from 'react';
import { useProgress } from '../context/ProgressContext';
import { ModuleType } from '../types/progress';

export const useTheoryProgress = (moduleType: ModuleType) => {
  const { markAsCompleted } = useProgress();

  useEffect(() => {
    // Track when user reaches the bottom of the page
    const handleScroll = () => {
      const scrolledToBottom = 
        window.innerHeight + Math.round(window.scrollY) >= document.documentElement.scrollHeight - 100;

      if (scrolledToBottom) {
        markAsCompleted(moduleType, 'theory', `${moduleType}-theory`);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [moduleType, markAsCompleted]);
};
